// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-3nZ2s","inner":"inner-1DWCP","submit":"submit-1Q0jl"};